// B-136 — a read that is asked again when the server was momentarily unable to answer: a 503
// `DATABASE_UNAVAILABLE` (every connection of the cierres pool busy) or a request that failed outright.
// A refusal the server meant (403, 404, 400) is returned as it came, never asked again.
const esperar = (ms) => new Promise((ok) => setTimeout(ok, ms));

export const pasajero = (r) => r === null || r === undefined || r?.errorCode === "DATABASE_UNAVAILABLE" || r?.status === 503;

export async function conReintento(pedir, { intentos = 3, espera = 1500 } = {}) {
  let ultima = null;
  for (let i = 0; i < intentos; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    ultima = await Promise.resolve().then(pedir).catch(() => null);
    if (!pasajero(ultima)) return ultima;
    // eslint-disable-next-line no-await-in-loop
    if (i < intentos - 1) await esperar(espera * (i + 1));
  }
  return ultima;
}
